export class EnaioOrganisation {
    id: string;
    name: string;
    active = false;
}
